import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import DashboardLayout from '@/components/feature/DashboardLayout';

export default function AdminPage() {
  const { isSuperuser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isSuperuser) {
      navigate('/admin/clientes', { replace: true });
    }
  }, [isSuperuser, navigate]);

  if (!isSuperuser) {
    return (
      <DashboardLayout>
        <div className="max-w-6xl flex flex-col items-center justify-center py-20">
          <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center mb-4">
            <i className="ri-lock-line text-red-600 text-2xl"></i>
          </div>
          <h2 className="text-lg font-bold text-foreground-900 mb-2">Acesso Restrito</h2>
          <p className="text-sm text-foreground-500 text-center max-w-md">
            Esta área é reservada para o superusuário administrador da plataforma. Faça login com as
            credenciais de administrador para acessar.
          </p>
        </div>
      </DashboardLayout>
    );
  }

  return null;
}
